import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./common/Components/Header/Header";
import ScrollToTop from "./common/Components/ScrollToTop/ScrollToTop";
import Home from "./pages/Home";
// import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
// import AirportParking from "./pages/AirportParking";
import Footer from "./common/Components/Footer/Footer";
import { allRoutes } from "../src/common/libs/allRoutes"
import Search from "./pages/Search";
import Booking from "./pages/Booking";
import Success from "./pages/Success";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import Faqs from "./pages/Faqs";
import Payment from "./pages/Payment";
// Airport Landing Pages
import HeathrowAirportParking from "./pages/HeathrowAirportParking";
import GatwickAirportParking from "./pages/GatwickAirportParking";
import ManchesterAirportParking from "./pages/ManchesterAirportParking";
import StanstedAirportParking from "./pages/StanstedAirportParking";
import BristolAirportParking from "./pages/BristolAirportParking";
import LutonAirportParking from "./pages/LutonAirportParking";
import BirminghamAirportParking from "./pages/BirminghamAirportParking";
import GatwickNorthTerminalParking from "./pages/GatwickNorthTerminalParking";
import GatwickSouthTerminalParking from "./pages/GatwickSouthTerminalParking";
import MeetAndGreetParking from "./pages/MeetAndGreetParking";
import ParkAndRideParking from "./pages/ParkAndRideParking";
import CompanyDetail from "./pages/CompanyDetail";
import Sitemap from "./pages/Sitemap";
import { trackPageView } from "./common/libs/tracking";

const App = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const href =
      window.location.pathname +
      window.location.search +
      window.location.hash;
    trackPageView(href);
  }, [location.pathname, location.search]);

  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <Routes>
            {allRoutes?.map((route, index) => {
              return route === "/search" ? (
                <Route key={index} path={route} element={<Search />} />
              ) : route === "/booking" ? (
                <Route key={index} path={route} element={<Booking />} />
              ) : route === "/success" ? (
                <Route key={index} path={route} element={<Success />} />
              ) : route === "/about-us" ? (
                <Route key={index} path={route} element={<Home />} />
              ) : route === "/contact-us" ? (
                <Route key={index} path={route} element={<ContactUs />} />
              ) : route === "/privacy-policy" ? (
                <Route key={index} path={route} element={<PrivacyPolicy />} />
              ) : route === "/terms-and-conditions" ? (
                <Route key={index} path={route} element={<TermsAndCondition />} />
              ) : route === "/refund-policy" ? (
                <Route key={index} path={route} element={<Home />} />
              ) : route === "/faqs" ? (
                <Route key={index} path={route} element={<Faqs />} />
              ) : route === "/payment" ? (
                <Route key={index} path={route} element={<Payment />} />
              ) : route === "/heathrow-airport-parking" ? (
                <Route key={index} path={route} element={<HeathrowAirportParking />} />
              ) : route === "/gatwick-airport-parking" ? (
                <Route key={index} path={route} element={<GatwickAirportParking />} />
              ) : route === "/gatwick-airport-parking/gatwick-north-terminal-parking" ? (
                <Route key={index} path={route} element={<GatwickNorthTerminalParking />} />
              ) : route === "/gatwick-airport-parking/gatwick-south-terminal-parking" ? (
                <Route key={index} path={route} element={<GatwickSouthTerminalParking />} />
              ) : route === "/manchester-airport-parking" ? (
                <Route key={index} path={route} element={<ManchesterAirportParking />} />
              ) : route === "/stansted-airport-parking" ? (
                <Route key={index} path={route} element={<StanstedAirportParking />} />
              ) : route === "/bristol-airport-parking" ? (
                <Route key={index} path={route} element={<BristolAirportParking />} />
              ) : route === "/luton-airport-parking" ? (
                <Route key={index} path={route} element={<LutonAirportParking />} />
              ) : route === "/birmingham-airport-parking" ? (
                <Route key={index} path={route} element={<BirminghamAirportParking />} />
              ) : route === "/meet-and-greet-parking" ? (
                <Route key={index} path={route} element={<MeetAndGreetParking />} />
              ) : route === "/park-and-ride-parking" ? (
                <Route key={index} path={route} element={<ParkAndRideParking />} />
              ) : route === "/sitemap" ? (
                <Route key={index} path={route} element={<Sitemap />} />
              ) : route === "/gatwick-airport-parking/:companySlug" ||
                route === "/heathrow-airport-parking/:companySlug" ||
                route === "/manchester-airport-parking/:companySlug" ||
                route === "/stansted-airport-parking/:companySlug" ||
                route === "/birmingham-airport-parking/:companySlug" ||
                route === "/bristol-airport-parking/:companySlug" ||
                route === "/luton-airport-parking/:companySlug" ? (
                <Route key={index} path={route} element={<CompanyDetail />} />
              ) : (
                <Route key={index} path={route} element={<Home />} />
              );
            })}
            {/* Manage Booking */}
            <Route path="/manage-booking" element={<React.Suspense fallback={<div className="p-8 text-center">Loading...</div>}><LazyManageBooking /></React.Suspense>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

const LazyManageBooking = React.lazy(() => import("./containers/ManageBooking/CustomerDashboard"));

export default App;
